"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FastAPIErrorAttributes$ = exports.FastAPIErrorAttributes$outboundSchema = exports.FastAPIErrorAttributes$inboundSchema = exports.Detail$ = exports.Detail$outboundSchema = exports.Detail$inboundSchema = exports.FastAPIErrorAttributes = void 0;
exports.detailToJSON = detailToJSON;
exports.detailFromJSON = detailFromJSON;
const z = __importStar(require("zod"));
const primitives_js_1 = require("../../../lib/primitives.js");
const schemas_js_1 = require("../../../lib/schemas.js");
const shared = __importStar(require("../shared/index.js"));
const krakensdkerror_js_1 = require("./krakensdkerror.js");
class FastAPIErrorAttributes extends krakensdkerror_js_1.KrakenSDKError {
    constructor(err, httpMeta) {
        const message = "message" in err && typeof err.message === "string"
            ? err.message
            : `API error occurred: ${JSON.stringify(err)}`;
        super(message, httpMeta);
        this.data$ = err;
        this.detail = err.detail;
        this.krakenVersion = err.krakenVersion;
        this.requestId = err.requestId;
        this.status = err.status;
        this.title = err.title;
        this.name = "FastAPIErrorAttributes";
    }
}
exports.FastAPIErrorAttributes = FastAPIErrorAttributes;
/** @internal */
exports.Detail$inboundSchema = z
    .union([z.array(shared.ValidationErrorAttributes$inboundSchema), z.string()]);
/** @internal */
exports.Detail$outboundSchema = z.union([
    z.array(shared.ValidationErrorAttributes$outboundSchema),
    z.string(),
]);
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var Detail$;
(function (Detail$) {
    /** @deprecated use `Detail$inboundSchema` instead. */
    Detail$.inboundSchema = exports.Detail$inboundSchema;
    /** @deprecated use `Detail$outboundSchema` instead. */
    Detail$.outboundSchema = exports.Detail$outboundSchema;
})(Detail$ || (exports.Detail$ = Detail$ = {}));
function detailToJSON(detail) {
    return JSON.stringify(exports.Detail$outboundSchema.parse(detail));
}
function detailFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.Detail$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'Detail' from JSON`);
}
/** @internal */
exports.FastAPIErrorAttributes$inboundSchema = z.object({
    detail: z.union([
        z.array(shared.ValidationErrorAttributes$inboundSchema),
        z.string(),
    ]),
    kraken_version: z.string(),
    request_id: z.nullable(z.string()),
    status: z.number().int(),
    title: z.string(),
    request$: z.instanceof(Request),
    response$: z.instanceof(Response),
    body$: z.string(),
})
    .transform((v) => {
    const remapped = (0, primitives_js_1.remap)(v, {
        "kraken_version": "krakenVersion",
        "request_id": "requestId",
    });
    return new FastAPIErrorAttributes(remapped, {
        request: v.request$,
        response: v.response$,
        body: v.body$,
    });
});
/** @internal */
exports.FastAPIErrorAttributes$outboundSchema = z.instanceof(FastAPIErrorAttributes)
    .transform(v => v.data$)
    .pipe(z.object({
    detail: z.union([
        z.array(shared.ValidationErrorAttributes$outboundSchema),
        z.string(),
    ]),
    krakenVersion: z.string(),
    requestId: z.nullable(z.string()),
    status: z.number().int(),
    title: z.string(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        krakenVersion: "kraken_version",
        requestId: "request_id",
    });
}));
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var FastAPIErrorAttributes$;
(function (FastAPIErrorAttributes$) {
    /** @deprecated use `FastAPIErrorAttributes$inboundSchema` instead. */
    FastAPIErrorAttributes$.inboundSchema = exports.FastAPIErrorAttributes$inboundSchema;
    /** @deprecated use `FastAPIErrorAttributes$outboundSchema` instead. */
    FastAPIErrorAttributes$.outboundSchema = exports.FastAPIErrorAttributes$outboundSchema;
})(FastAPIErrorAttributes$ || (exports.FastAPIErrorAttributes$ = FastAPIErrorAttributes$ = {}));
//# sourceMappingURL=fastapierrorattributes.js.map